module.exports = "/images/discover-7.png";